import { IoIosArrowBack } from "react-icons/io";
import { db } from "../firebaseConfig";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { useState } from "react";
import AddUser from "../components/AddUser";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import Swal from "sweetalert2";
import { updateDoc, doc } from "firebase/firestore";
import { httpsCallable, getFunctions } from "firebase/functions";
import { IoIosRefresh } from "react-icons/io";
import { auth } from "../firebaseConfig";

export default function ManageUsers({printAllUsers, user, setUser, setUserCheck, handleClick, handleClose, anchorEl, openMenuRowName}) {
    const [addUserCheck, setAddUserCheck] = useState(false);
    const currentUser = auth.currentUser;
    const [editRowName, setEditRowName] = useState(null);
    const open = Boolean(anchorEl);
    const ITEM_HEIGHT = 48;
    const options = [
        {name: 'Edit User Role'},
        {name: 'Force Reset Password'},
        {name: 'Delete Account'},
    ];

    const forceResetPassword = async (userId) => {
        if (!userId) return;
    
        const userRef = doc(db, "users", userId);
        await updateDoc(userRef, { mustResetPassword: true });
          
        Swal.fire({ 
            icon: "success",
            title: "Password Reset Forced",
            text: "The user will be prompted to reset their password on next login.",
            confirmButtonColor: "#3085d6",
        });
    };

    const handleMenuAction = (action, rowName, userId) => {
        const functions = getFunctions();
        const deleteUser = httpsCallable(functions, "deleteUser");
        handleClose();
    
        switch(action) {
            case "Edit User Role":
                setEditRowName(rowName);
                break;
    
            case "Force Reset Password":
                try {
                    forceResetPassword(userId);
                }
                    
                catch (e) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: e,
                        confirmButtonColor: "#3085d6",
                    });
                }
                break;
    
            case "Delete Account":
                Swal.fire({
                    title: "Are you sure?",
                    text: "This action cannot be undone!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes, delete it!"
                    }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            await deleteUser({ uid: userId });
                            setUser(prevUsers => prevUsers.filter(u => u.id !== userId));
                            Swal.fire({
                                toast: true,
                                position: 'bottom', 
                                icon: 'success',
                                title: 'User Deleted!',
                                showConfirmButton: false,
                                timer: 3000,
                                customClass: {
                                    popup: 'swal-bottom-center'
                                }
                            });
                        } catch (e) {
                            Swal.fire({
                                icon: "error",  
                                title: "Error",
                                text: e,
                                confirmButtonColor: "#3085d6",
                            });
                        }
                    }
                });
                break;

            default: 
                console.warn(`Unknown Action ${action}`)
        } 
    }

    const handleRoleChange = async (e, userId) => {
        e.preventDefault();
        const newRole = e.target.value;
        if (!userId) {
            console.error("ERROR: userId is undefined");
            return;
        }
    
        const userRef = doc(db, "users", userId);
        await updateDoc(userRef, { role: newRole });
    
        setUser(prev =>
            prev.map(u =>
                u.id === userId ? { ...u, role: newRole } : u
            )
        );
        setEditRowName(null);
    };

    const toDateOnly = (timestamp) => {
        if (!timestamp) return "";
        let date = timestamp.toDate();
    
        if (isNaN(date.getTime())) {
            return ""; 
        }
    
        return date.toISOString().split('T')[0];
    };

    return (
        <div className="manage-user-background">
            <div className="user-back-button" onClick={() => setUserCheck(false)}>
                <IoIosArrowBack onClick={() => setUserCheck(false)} style={{width: "100%", height: "100%", color: "#EFBF84"}}/>
            </div>
                        
            <h3 style={{marginTop: "-32px", marginBottom: "20px", marginLeft: "35px",textAlign: "left"}}>Manage Users</h3>
            <div className="add-user-div">
            <div className="refresh-button" onClick={() => printAllUsers()}>
                <IoIosRefresh onClick={() => printAllUsers()} style={{width: "100%", height: "100%", color: "#EFBF84"}}/>
            </div>
                <button className="add-user-button" title="Add New User" onClick={() => setAddUserCheck(true)}><PersonAddIcon /> Add New User</button>
            </div>
            {addUserCheck ? <><AddUser printAllUsers={printAllUsers} setAddUserCheck={setAddUserCheck} /> <button className="close-add-user-button" onClick={() => setAddUserCheck(false)}>Cancel</button></> : null}
            <div className="user-table">
                <TableContainer style={{backgroundColor: "#ffffffff", boxShadow: '0px 0px 0px rgba(0,0,0,0.0)',}} component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell><strong>User Email</strong></TableCell>
                                <TableCell align="right"><strong>Date Created</strong></TableCell>
                                <TableCell align="right"><strong>Role</strong></TableCell>
                                <TableCell align="right"><strong>Is Verified?</strong></TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {user.map((users) => (
                                <TableRow key={users.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">{users.email}</TableCell>
                                    <TableCell align="right">{toDateOnly(users.createdAt)} </TableCell>
                                    <TableCell align="right">{editRowName === users.email ? (
                                        <Box style={{ minWidth: 10, backgroundColor: "white", borderRadius: "8px"}}>
                                            <FormControl fullWidth size="small">
                                            <InputLabel id="demo-simple-select-label"sx={{"&.Mui-focused": { color: "black" }}}>Role</InputLabel >
                                            <Select labelId="demo-simple-select-label" id="demo-simple-select" value={''} label="Role" onChange={(e) => handleRoleChange(e, users.id)} 
                                                sx={{"&.Mui-focused .MuiOutlinedInput-notchedOutline": {borderColor: "black", color: "black"}}}>
                                                <MenuItem selected disabled>Select One</MenuItem>
                                                <MenuItem value="user">User</MenuItem>
                                                <MenuItem value="admin">Admin</MenuItem>
                                            </Select>
                                            </FormControl>
                                        </Box>
                                        ) : (
                                        <>
                                            {users.role}
                                        </>)}
                                    </TableCell>
                                    <TableCell align="right">{users.emailVerified ? "Yes" : "No"}</TableCell>
                                    <TableCell align="right">
                                        <IconButton aria-label="more" id="long-button" aria-controls={open ? 'long-menu' : undefined}
                                            aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={(event) => handleClick(event, users.email)}>
                                            <MoreVertIcon style={{color: "black"}}/>
                                        </IconButton>
                                        <Menu id="long-menu" anchorEl={anchorEl} open={openMenuRowName === users.email} onClose={handleClose}
                                            slotProps={{
                                                paper: {
                                                    style: {
                                                    maxHeight: ITEM_HEIGHT * 4.5,
                                                    width: '22ch',
                                                },
                                            },
                                            list: {
                                                'aria-labelledby': 'long-button',
                                            },
                                            }}>
                                            {options.map((option) => (
                                            <MenuItem key={option.name} disabled={
                                                (option.name === "Edit User Role" || option.name === "Delete Account") &&
                                                users.id === currentUser?.uid} onClick={() => handleMenuAction(option.name, users.email, users.id)}>
                                                {option.name}
                                            </MenuItem>
                                            ))}
                                        </Menu>
                                    
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}